import { useCallback, useSyncExternalStore } from 'react';
import { CompositeFieldType } from '#types/System.types';
import {
    getCompositeFieldType,
    getCompositeFieldTypeCached,
    onCompositeFieldTypeCacheInvalidated,
} from './compositeFieldTypeCache';

/**
 * Returns a single CompositeFieldType by ID from a static cache.
 * Re-fetches automatically when the cache is invalidated.
 */
export const useCompositeFieldType = (id: string): CompositeFieldType | null => {
    const subscribe = useCallback((callback: () => void) => {
        if (!id) return () => {};
        getCompositeFieldType(id).then(callback);
        return onCompositeFieldTypeCacheInvalidated(() => {
            getCompositeFieldType(id).then(callback);
        });
    }, [id]);

    const getSnapshot = useCallback(() => id ? getCompositeFieldTypeCached(id) : null, [id]);

    return useSyncExternalStore(subscribe, getSnapshot);
};
